import { FeatureFlag } from "frontend-admin/src/constants/FEATURE_FLAGS";
import { FacilityFlags } from "frontend-admin/src/containers/facilityUser/helpers";
import { Session } from "frontend-admin/src/modules/interface";
import { getLocation } from "frontend-admin/src/utils/routes";
import { logEvent } from "frontend-admin/src/utils/segment/logEvents";
import { HCF_USER_EVENTS } from "frontend-admin/src/constants/firebaseEvents";

export function evaluateWorkplaceToWorkplaceReferrals(
  userFlags: FacilityFlags,
  user: Session["user"],
  isFacility: boolean,
): boolean {
  const { workplaceToWorkplace } =
    userFlags?.[FeatureFlag.WORKPLACE_REFERRALS] ?? {};
  return (
    workplaceToWorkplace === true &&
    isFacility &&
    user?.isEmailVerified === true &&
    !user.isSuspicious
  );
}

export function getReferralUrl(referralCode: string) {
  const path = getLocation("workplaceGetAccess", {
    queryParams: { "referral-code": referralCode },
  });
  return `${location.protocol}//${location.host}${path.pathname}?${path.search}`;
}

export function logReferAndEarnEvents({
  action,
  workplaceId,
  workplaceUserId,
  source,
}: {
  action: string;
  workplaceId: string;
  workplaceUserId: string;
  source?: string;
}) {
  logEvent(HCF_USER_EVENTS.WORKPLACE_REFER_AND_EARN, {
    action,
    workplaceId,
    workplaceUserId,
    source,
  });
}
